import Vue from "vue";
import DataService from "@/services/data-service/data-service";

export default abstract class RESTApiEndPoints {
  public static localServer(): string {
    return (Vue.prototype.$dataService as DataService).getters.getBackendUrl();
  }

  static shipsUrl = () => `${RESTApiEndPoints.localServer()}/api/ships`;
  static companiesUrl = () => `${RESTApiEndPoints.localServer()}/api/companies`;
  static usersUrl = () => `${RESTApiEndPoints.localServer()}/api/users`;
  static groupCompaniesUrl = () => `${RESTApiEndPoints.localServer()}/api/companygroups`;
  static wastesUrl = () => `${RESTApiEndPoints.localServer()}/api/wastetypes`;
  static manyWasteBulkUrl = () => `${RESTApiEndPoints.localServer()}/api/wastebulks/many`;
  static wasteBulkRecordUrl = () => `${RESTApiEndPoints.localServer()}/api/wastebulkrecords`;
  static bilgeProductionUrl = () => `${RESTApiEndPoints.localServer()}/api/bilgeproductions`;
  static freshWaterConsumptionUrl = () =>
    `${RESTApiEndPoints.localServer()}/api/FreshWaterConsumptions`;
  static epmdHeaderUrl = () => `${RESTApiEndPoints.localServer()}/api/EPMD/header/`;
  static epmdDataUrl = () => `${RESTApiEndPoints.localServer()}/api/EPMD/data/`;
  static epmdSyncUrl = () => `${RESTApiEndPoints.localServer()}/api/EPMD/sync/`;
  static epmdUrl = () => `${RESTApiEndPoints.localServer()}/api/EPMD/`;
  static gasVolumesUrl = () => `${RESTApiEndPoints.localServer()}/api/gasVolumes`;
  static logUrl = () => `${RESTApiEndPoints.localServer()}/api`;
  static compartmentAssessmentsUrl = () =>
    `${RESTApiEndPoints.localServer()}/api/CompartmentAssessments`;
  static shipAreaFindingsUrl = () => `${RESTApiEndPoints.localServer()}/api/ShipAreaFindings`;
  static conditionAssessmentsUrl = () =>
    `${RESTApiEndPoints.localServer()}/api/ConditionAssessments`;
  static ItinerariesUrl = () => `${RESTApiEndPoints.localServer()}/api/Itineraries`;
  static UploadsUrl = () => `${RESTApiEndPoints.localServer()}/api`;
  static RAGsUrl = () => `${RESTApiEndPoints.localServer()}/api/rags`;
  static ImportUrl = () => `${RESTApiEndPoints.localServer()}/api/import`;
  static loginUrl = () => `${RESTApiEndPoints.localServer()}/api/login`;
  static messageInfoUrl = () => `${RESTApiEndPoints.localServer()}/api/messageinfo`;
  static portsUrl = () => `${RESTApiEndPoints.localServer()}/api/ports`;
  static wasteTypesUrl = () => `${RESTApiEndPoints.localServer()}/api/wastetypes`;
  static wasteGroupsUrl = () => `${RESTApiEndPoints.localServer()}/api/wastegroups`;
  static wasteCategoriesUrl = () => `${RESTApiEndPoints.localServer()}/api/wastecategories`;
  static wasteSubCategoriesUrl = () => `${RESTApiEndPoints.localServer()}/api/wastesubcategories`;
  static countriesUrl = () => `${RESTApiEndPoints.localServer()}/api/countries`;
  static measurementUnitsUrl = () => `${RESTApiEndPoints.localServer()}/api/measurementunits`;
  static poolDrainOptionsUrl = () => `${RESTApiEndPoints.localServer()}/api/pooldrainoptions`;
  static averagesUrl = () => `${RESTApiEndPoints.localServer()}/api/averages`;
}
